module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/other/browserconfig-984c73468b8ad06e2fa0d6eb067e975d.xml";